import { Pipe, PipeTransform } from '@angular/core';

import { PrestationForm } from '@gi/forms/prestation-form';
import { Prestation } from '@gi/models/prestation';

type DataType = Prestation | PrestationForm;

@Pipe({
  name: 'prestationsGroupByOffer',
  standalone: true
})
export class PrestationsGroupByOfferPipe implements PipeTransform {
  transform(data: DataType[]): DataType[] {
    return data.sort((a: DataType, b: DataType) => {
      const aContractOffer = a instanceof Prestation ? a.contractOffer?.offer : a.contractOffer.value?.offer;
      const bContractOffer = b instanceof Prestation ? b.contractOffer?.offer : b.contractOffer.value?.offer;

      return aContractOffer && bContractOffer
        ? aContractOffer?.id < bContractOffer?.id
          ? -1
          : 1
        : aContractOffer && !bContractOffer
          ? -1
          : 1;
    });
  }
}
